import { withAssetPrefix } from 'gatsby';

export const create_breadcrumb = (item_list_element) => {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement":
      item_list_element.map(element => {
        return {
          "@type": "ListItem",
          "position": element.position,
          "name": element.name,
          "item": `https://social-dog.net${element.item}`,
        }
      })
  }
};

export const create_howto = (title, steps, url) => {
  return {
    "@context": "http://schema.org",
    "@type": "HowTo",
    "name": title,
    "step":
      steps.map(step => {
        let howto_step = {
          "@type": "HowToStep",
          "url": `https://social-dog.net${url}#${title}`,
          "text": step.text,
        };
        if (step.image) {
          howto_step['image'] = {
            "@type": "ImageObject",
            "url": withAssetPrefix(step.image),
          }
        }
        return howto_step;
      }),
  }
};

export const create_faq = (questions) => {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity":
      questions.map(question => {
        return {
          "@type": "Question",
          "name": question.title,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": question.html,
          }
        };
      }),
  }
}